import { useCallback, useState } from 'react';

/**
 * SAYFALAMA VE SÜZGEÇ DURUMU.
 *
 * İzin, görev ve dönem ekranlarının üçü de sayfalı liste gösteriyor ve
 * üçünde de aynı kural geçerli: SÜZGEÇ DEĞİŞİNCE SAYFA 1'E DÖNER. Aksi
 * halde 4. sayfadayken birim değiştiren kullanıcı boş bir liste görür ve
 * bunu "kayıt yok" sanar.
 *
 * `PersonelListesi` bu kuralı elle uyguluyor (`sayfaYaz(1)` her süzgeç
 * yazımından önce). Üç ekranda daha elle tekrarlanacak olsaydı biri
 * unutulurdu; kanca kuralı yapısal olarak zorunlu kılar.
 */

/** Sunucu tavanı (`MAX_SAYFA_BOYUTU`). Üstü istense de uygulanmaz. */
export const EN_BUYUK_SAYFA_BOYUTU = 100;

/** Sayfa boyutu seçicisi olan ekranlar bu kümeyi kullanır. */
export const SAYFA_BOYUTLARI = [25, 50, 100] as const;

export interface SayfalamaDurumu<S> {
  suzgec: S;
  /**
   * Süzgeci günceller ve sayfayı 1'e alır. Kısmi güncelleme için önceki
   * değeri alan bir işlev verilebilir.
   */
  suzgeciYaz: (yeni: S | ((onceki: S) => S)) => void;
  sayfa: number;
  sayfayaGit: (yeni: number) => void;
  sayfaBoyutu: number;
  sayfaBoyutunuYaz: (yeni: number) => void;
}

export function sayfalamaKullan<S>(ilkSuzgec: S, ilkSayfaBoyutu = 25): SayfalamaDurumu<S> {
  const [suzgec, suzgecDurumuYaz] = useState<S>(ilkSuzgec);
  const [sayfa, sayfaYaz] = useState(1);
  const [sayfaBoyutu, sayfaBoyutuDurumuYaz] = useState(() =>
    Math.min(ilkSayfaBoyutu, EN_BUYUK_SAYFA_BOYUTU),
  );

  const suzgeciYaz = useCallback((yeni: S | ((onceki: S) => S)) => {
    suzgecDurumuYaz((onceki) =>
      typeof yeni === 'function' ? (yeni as (o: S) => S)(onceki) : yeni,
    );
    sayfaYaz(1);
  }, []);

  const sayfaBoyutunuYaz = useCallback((yeni: number) => {
    // Sunucu tavanı aşılırsa istenen boyut sessizce uygulanmaz ve toplam
    // sayfa sayısı yanlış hesaplanır.
    sayfaBoyutuDurumuYaz(Math.min(Math.max(1, yeni), EN_BUYUK_SAYFA_BOYUTU));
    sayfaYaz(1);
  }, []);

  const sayfayaGit = useCallback((yeni: number) => {
    sayfaYaz(Math.max(1, yeni));
  }, []);

  return { suzgec, suzgeciYaz, sayfa, sayfayaGit, sayfaBoyutu, sayfaBoyutunuYaz };
}
